import { dateOf } from "@repo/helpers";
import { Column, DateColumn, GridBaseProps, GridPreLoaded, Loading } from "@repo/ui";
import { FC, useMemo } from "react";

import { useLocationQueries } from "../../api/locationApi";
import { useLocationContext } from "../../contexts/editableItemContext";
import { LocationStatus } from "../../models";

interface Props extends GridBaseProps<LocationStatus> {}

export const StatusHistoriesGrid: FC = (props: Props) => {
	const locationContext = useLocationContext();
	const { locationId } = locationContext;
	const { useStatusHistoriesQuery } = useLocationQueries();
	const { data: statusHistories, loading, clearQuery } = useStatusHistoriesQuery(locationId);

	const columns = useMemo(
		() =>
			[
				new DateColumn("Timestamp", "createdOn"),
				new Column("Status", "statusName"),
				new Column("Action", "action"),
				new Column("Effective Start Date - Expected End Date").withFormat((item) => (
					<StartEndColumn {...item} />
				)),
				new Column("Notes", "notes"),
				new Column("User", "createdBy"),
			].filter(Boolean) as Column<LocationStatus>[],
		[],
	);

	if (!locationId) {
		return null;
	}

	return (
		<Loading loading={loading} message="Loading Status Histories..." fullHeight>
			<div className="m-4">
				<GridPreLoaded<LocationStatus>
					{...props}
					id="statusHistoryGrid"
					title="Status History"
					values={statusHistories ?? []}
					columns={columns}
					loading={loading}
					refresh={clearQuery}
					getData={clearQuery}
					keyProperty="id"
					totalItems={statusHistories?.length ?? 0}
					pageSize={5}
				/>
			</div>
		</Loading>
	);
};

export const StartEndColumn: FC<LocationStatus> = (statusHistory) => {
	const { startDate, endDate } = statusHistory;

	if (startDate && endDate)
		return (
			<>
				{dateOf(startDate)} - {dateOf(endDate)}
			</>
		);
	else if (startDate) return <>{dateOf(startDate)} - </>;
	return null;
};
